export default __webpack_public_path__ + "static/08-fbc2e83fa99db7b76fc9897e3d9fc75b.jpg";